class Person {
    id = null;
    first_name = '';
    last_name = '';
    oib = '';
    emails = [];
    phones = [];
    addresses = [];
    foreign = false;
    oib_label = 'OIB';
    active = true;
    user_id = null;
    member_id = '';
    gender_id = null;
    date_of_birth = null;
    company_id = null;
    allows_communication = false;
    accepts_gdpr = false;
    note = '';
    documents = [];
    photo = {name: '', link: '', id: 0};

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Person;
